import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "finance-bar" }
const _hoisted_2 = { class: "balance-wrap" }
const _hoisted_3 = { class: "flex justify-center flex-1" }
const _hoisted_4 = { class: "balance-value" }
const _hoisted_5 = { class: "action-btn-bar flex" }
const _hoisted_6 = { class: "action-btn-title" }
const _hoisted_7 = { class: "action-btn-title" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore, useAccountStore } from "@/store";


export default {
  __name: 'FinanceBar',
  setup(__props) {

const userStore = useUserStore();
const { username } = storeToRefs(userStore);
const accountStore = useAccountStore();
const { balance } = storeToRefs(accountStore);

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          class: "coin-icon",
          src: require('@/assets/img/common/coin.png')
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filter.outputAmount(_unref(balance))), 1),
        _withDirectives(_createVNode(_component_van_image, {
          class: "action-icon",
          src: require('@/assets/img/common/refresh.png'),
          onClick: _cache[0] || (_cache[0] = $event => (_unref(accountStore).fetchBalance()))
        }, null, 8, ["src"]), [
          [_directive_audio]
        ])
      ]),
      _createElementVNode("div", null, _toDisplayString(_unref(username)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "action-btn",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'withdraw' })))
      }, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.withdraw').toUpperCase()), 1)
      ])), [
        [_directive_audio]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "action-btn deposit",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push({ name: 'recharge' })))
      }, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('common.deposit').toUpperCase()), 1)
      ])), [
        [_directive_audio]
      ])
    ])
  ]))
}
}

}